/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_DescriptionInputs */



/**
* | output |
* | --- |
* | "Divide the selected source Event Group into smaller Event Groups." |
*
* @param {Segment_Event_Group_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_description = /** @type {((inputs?: Segment_Event_Group_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Diviser le groupe d'evenements source en groupes d'evenements plus petits.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Teilen Sie die ausgewählte Quellereignisgruppe in kleinere Ereignisgruppen auf.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dividere il gruppo di eventi sorgente selezionato in gruppi di eventi più piccoli.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разделите выбранную исходную группу событий на более мелкие группы событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Divida el grupo de eventos de origen seleccionado en grupos de eventos más pequeños.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将选定的源事件组拆分为更小的事件组。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したソース イベント グループを小さなイベント グループに分割します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित स्रोत इवेंट समूह को छोटे-छोटे इवेंट समूहों में विभाजित करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Divida o grupo de eventos de origem selecionado em grupos de eventos menores.")
	return /** @type {LocalizedString} */ ("Divide the selected source Event Group into smaller Event Groups.")
});